var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBouncedOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 6.72,
    fill: "#FF543E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4444 10.9444L21.5556 22.0556M24 16.5C24 20.9183 20.4183 24.5 16 24.5C11.5817 24.5 8 20.9183 8 16.5C8 12.0817 11.5817 8.5 16 8.5C20.4183 8.5 24 12.0817 24 16.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBouncedOverview);
export default __webpack_public_path__ + "static/media/bounced-overview.fe52f775c4b3354fa665564f98167dc0.svg";
export { ForwardRef as ReactComponent };